module.exports = __webpack_public_path__ + "static/media/logo.44496db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 177
// module chunks = 0